module.exports = __webpack_public_path__ + "static/media/img26.ec6e5e71.JPG";